import Axios from 'axios';

import Store from '@/store';
import PathUtils from '@/utils/path';

export default {
  /**
   * fetch function to call axios
   * @async
   * @param {FetchOptions} options {method, url, data, headers}
   * @returns {Promise} Promise with the result of the axios request
   */
  async fetch(options) {
    const isJWT = options.data && options.data.jwt;
    const axiosOptions = {
      method: options.method,
      url: `${PathUtils.resolve(isJWT ? 'jwt' : 'api').path}${options.url}`,
      data: options.data,
      headers: {
        Authorization: Store.getters.token ? `Bearer ${Store.getters.token}` : null,
        ...options.headers,
      },
    };

    // Recover localstorage from token in vuex
    if (!localStorage.getItem('hub-facilitator-portal-token')) {
      await Store.dispatch('updateAuthToken', {
        newToken: Store.getters.token,
      });
    }

    const response = await Axios(axiosOptions);

    if (!response || !response.data) {
      return { success: false, message: 'Server error' };
    }

    if (!response.data.success) {
      if (['JsonWebTokenError', 'TokenExpiredError'].includes(response.data.message)) {
        await Store.dispatch('clearSession');
        window.location.replace(PathUtils.getPaths('app').url);
      }

      return { success: false, message: response.data.message };
    }

    // Replace old token if server send a new token back
    if (response.headers && response.headers['renewed-token']) {
      await Store.dispatch('updateAuthToken', {
        newToken: response.headers['renewed-token'],
      });

      return response.data;
    }

    // A new token from login response
    if (response.headers && response.headers['new-token']) {
      response.data.newToken = response.headers['new-token'];
    }

    return response.data;
  },

  get(url, data) {
    return this.fetch({
      method: 'get',
      url,
      data,
    });
  },

  post(url, data) {
    return this.fetch({
      method: 'post',
      url,
      data,
    });
  },

  patch(url, data) {
    return this.fetch({
      method: 'patch',
      url,
      data,
    });
  },

  put(url, data) {
    return this.fetch({
      method: 'put',
      url,
      data,
    });
  },

  delete(url) {
    return this.fetch({
      method: 'delete',
      url,
    });
  },
};
